<template>
    <div>
      <h2>학생관리</h2>
      <p>
        학원관리>학생관리 메뉴에서 관리합니다.
      </p>
      
      <section>
        <div class="p-relative section_0" id="student_list">
            <div class="ft-b">1)    학생현황</div>
        
            <div class="p-relative section_1">
                -   검색할 월을 설정 후 조회버튼을 클릭합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/stat/stat_student_list.jpg" /></div>
            </div>
            <div class="p-relative section_1">
                -   학생현황에 나타나는 학생은 검색한 월에 수강한 학생이 나타납니다.
            </div>
        </div>


        <p></p>
        <div class="p-relative section_0" id="student_change">
            <div class="ft-b">2)    반별변동현황</div>
        
            <div class="p-relative section_1">
                -   검색할 월을 설정 후 조회버튼을 클릭합니다.
            </div>
            <div class="p-relative section_1">
                -   반별변동현황은 검색한 월에 입반/퇴반 학생수가 나타납니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/stat/stat_student_change.jpg" /></div>
            </div>
            <div class="p-relative section_1">
                -   검색된 결과를 엑셀로 다운로드하여 볼 수 있습니다.
            </div>

        </div>
        
      </section>

      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
import goto from "./goto.js";
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '학생현환', link: '#student_list' },
                { label: '반별변동현황', link: '#student_change' },
                
            ]
        }
    },
    computed :{
    },
    methods : {
        goTo(link) {
            goto.goto_link(link);
        }
    },
    beforeMount() {
        goto.clear();
    }
}
</script>


